<div class="flex h-full p-8 space-x-16">
  <!-- Left section: Form inputs and buttons -->
  <div class="flex-1 flex flex-col">
    <form [formGroup]="designationForm" class="flex flex-col h-full space-y-6">
      <!-- User selection -->
      <div class="flex flex-col">
        <span class="form-field-header">Select user or user collection*</span>
        <lib-cdw-autocomplete
          floatLabel="always"
          [placeholder]="userSelectionDisplayText || 'Select a user or user collection...'"
          formControlName="users"
          [values]="userSelectOptions"
          [showInternalSearch]="true"
          [multiSelect]="false"
          [dropdownHeight]="500"
          fontSize="14px"
          [fontWeight]="400"
          fontFamily="Roboto"
          (doneClicked)="onUserSelectionDone($event)"
        ></lib-cdw-autocomplete>
      </div>

      <!-- OU selection -->
      <div class="flex flex-col">
        <span class="form-field-header">Select OU or OU collection*</span>
        <lib-cdw-ou-collection-picker
          formControlName="ous"
          [ouTreeData]="ous"
          [ouCollections]="ouCollections"
          [multiSelect]="false"
          [progressiveParentSelect]="false"
          [placeholder]="ouSelectionDisplayText || 'Select an OU or OU collection...'"
        ></lib-cdw-ou-collection-picker>
      </div>

      <!-- Role selection -->
      <div class="flex flex-col">
        <span class="form-field-header">Assign role*</span>
        <lib-cdw-autocomplete
          formControlName="roles"
          [values]="roleSelectOptions"
          floatLabel="always"
          [placeholder]="roleSelectionDisplayText || 'Select role...'"
          [showInternalSearch]="true"
          [multiSelect]="true"
          [dropdownHeight]="500"
          fontSize="14px"
          [fontWeight]="400"
          fontFamily="Roboto"
          (doneClicked)="onRoleSelectionDone($event)"
        ></lib-cdw-autocomplete>
      </div>

      <!-- Spacer to push buttons to bottom -->
      <div class="flex-grow"></div>

      <!-- Action buttons -->
      <div class="flex flex-row justify-between items-end">
        <div *ngIf="designation">
          <lib-cdw-button (buttonClick)="onDeleteDesignation()" level="warn">Delete Designation</lib-cdw-button>
        </div>
        <div class="flex space-x-4 ml-auto">
          <lib-cdw-button
            (buttonClick)="onCancelDesignation()"
            level="secondary"
            fontFamily="Roboto, sans-serif"
            [fontColor]="grey400Color"
            fontWeight="700"
            >Cancel</lib-cdw-button
          >
          <lib-cdw-button
            (buttonClick)="onSaveDesignation()"
            level="primary"
            [disabled]="!isFormValid()"
            fontFamily="Roboto, sans-serif"
            [fontColor]="grey400Color"
            fontWeight="700"
            >Save Designation</lib-cdw-button
          >
        </div>
      </div>
    </form>
  </div>

  <!-- Right section: Message band -->
  <div class="flex-1 flex items-start pt-6 pr-16">
    <lib-cdw-message-band
      mode="info-white"
      [textColor]="grey300Color"
      fontWeight="500"
      fontFamily="Roboto, sans-serif"
      fontSize="16px"
      >To create a designation, select one user or user collection and one OU or OU collection, then assign a role. Note: To apply a designation to multiple individuals or OUs at once, please create a User or OU Collection first.</lib-cdw-message-band
    >
  </div>
</div>
